// extracted by mini-css-extract-plugin
export default {"price":"w7-z","onSale":"x7-z","msrpLabelPrice":"y7-z","msrpLabel":"z7-z","originalPrice":"A7-z","percentOff":"B7-z"};